import React from 'react';
import {
  ExpansionPanelSummary,
  Typography,
  ExpansionPanelDetails,
  ExpansionPanel,
  Grid,
  Divider,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const InitialAuditInformation = () => {
  return (
    <div className="initial-audit-info">
      <ExpansionPanel className="initial-audit-info__expansionPanel">
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <span className="initial-audit-badge initial-audit-badge__total"></span>
          <label className="initial-audit-info__expansionPanel-header">
            <span className="title">Total Records:</span>
            <span className="value">80</span>
          </label>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className="initial-audit-info__expansionPanel-details">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Typography align="left" className="title">
                Status
              </Typography>
              <Divider className="divider" />
              <Typography align="left" className="value">
                Audit Complete
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Typography align="left" className="title">
                Account Structure Mismatch
              </Typography>
              <Divider className="divider" />
              <Typography align="left" className="value">
                35
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Typography align="left" className="title">
                Product Mismatch
              </Typography>
              <Divider className="divider" />
              <Typography align="left" className="value">
                15
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Typography align="left" className="title">
                No Match
              </Typography>
              <Divider className="divider" />
              <Typography align="left" className="value">
                0
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Typography align="left" className="title">
                Policy Match
              </Typography>
              <Divider className="divider" />
              <Typography align="left" className="value">
                15
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Typography align="left" className="title">
                Coverage Difference
              </Typography>
              <Divider className="divider" />
              <Typography align="left" className="value">
                1
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Typography align="left" className="title">
                Non-Coverage Difference
              </Typography>
              <Divider className="divider" />
              <Typography align="left" className="value">
                0
              </Typography>
            </Grid>
          </Grid>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel className="initial-audit-info__expansionPanel">
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} id="audit-result-successful">
          <span className="initial-audit-badge initial-audit-badge__successful"></span>
          <label className="initial-audit-info__expansionPanel-header">
            <span className="title">Successful Imports:</span>
            <span className="value">20</span>
          </label>
        </ExpansionPanelSummary>

        <ExpansionPanelDetails></ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel className="initial-audit-info__expansionPanel">
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="audit-result"
          id="audit-result-unsuccessful"
        >
          <span className="initial-audit-badge initial-audit-badge__unsuccessful"></span>
          <label className="initial-audit-info__expansionPanel-header">
            <span className="title">Unsuccessful Imports:</span>
            <span className="value">50</span>
          </label>
        </ExpansionPanelSummary>

        <ExpansionPanelDetails className="initial-audit-info__expansionPanel-details">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Typography align="left" className="title">
                Account Structure Mismatch
              </Typography>
              <Divider className="divider" />
              <Typography align="left" className="value">
                35
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Typography align="left" className="title">
                Product Mismatch
              </Typography>
              <Divider className="divider" />
              <Typography align="left" className="value">
                15
              </Typography>
            </Grid>
          </Grid>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
};
export default InitialAuditInformation;
